import { render, staticRenderFns } from "./NexmoSmsForm.vue?vue&type=template&id=86ef9054"
import script from "./NexmoSmsForm.vue?vue&type=script&lang=js"
export * from "./NexmoSmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports